import { sendOTPApi } from 'entities/sendOTP/model';
import { IAvailableItem } from 'entities/sendOTP/types';
import { HTTP_METHODS } from 'shared/consts';

const getAvailableApi = sendOTPApi.injectEndpoints({
  endpoints: (builder) => ({
    getAvailable: builder.query<IAvailableItem[], null>({
      query: () => ({
        url: '/callpassword/admin/methods/available',
        method: HTTP_METHODS.GET,
      }),
      providesTags: ['SendOTP'],
    }),
  }),
});

export const { useGetAvailableQuery } = getAvailableApi;
